import Backbone from 'backbone'
import $ from 'jquery'
import Logger from 'Logger'
import _ from 'underscore'
import { AppDevInfoView } from './app-dev-info.view'
import {
  DecorationView,
  EmoticonView,
  GachaView,
  headerModel,
  HeaderView,
  HotDealView,
  ItemsView,
  LoadingView,
  payModel,
  PayView,
  PokerClassView,
  popupModel,
  PopupView,
} from './components'
import {
  getPokerClass,
  GOODS_ID,
  isDev,
  isOpenedGame,
  isOpenedWeb,
  setTrackingCode,
} from './config'
import { pay } from './manager/mall.event'
import store from './store'
import { loadingModel } from './store/loding.model'
import { eventBus } from './utils/eventBus'
import './utils/routie.min' // Routie hash router 전역으로 routie함 수 사용

// 템플릿
import tpl from './app.mustache'

export var PokerMallApp = Backbone.View.extend({
  tagName: 'div',
  className: 'mi6-mall', // 루트 엘리먼트

  template: tpl,

  model: store.list, // 상품 리스트

  loading: loadingModel,

  events: {
    'click .poker-mall__header-close': 'pokerMallClose',
    'click [data-vip-icon]': 'showVipCoupons',
  },

  paymentMode: false, // 상품 리스트 없이, 바로 결제화면 표시(클래스 페이지에서 사용)

  initialize: function (params) {
    this.params = params || {}

    // 이니셜 할때 굿즈 아이디가 있으면 결제 모드로 변경 결제창만 사용한다.
    this.paymentMode = !!(this.params && this.params.goodsId)

    this.render()

    // Header Init
    this.headerModel = headerModel

    // Event Bus
    eventBus.off()
    eventBus.on('$popupShow', this.$popupShow, this)
    eventBus.on('$pay', this.$pay, this) // 구매 팝업
    eventBus.on('mallRemove', this.pokerMallRemove, this)

    // 결제모드 분기
    if (this.paymentMode) {
      this.onlyPayment() // 구매 팝업
    } else {
      this.model.once('sync', this.afterSync, this)
      this.model.fetch()
    }
  },

  afterSync: function () {
    if (isDev) {
      this.$el
        .find('.mi6-mall__container')
        .append(new AppDevInfoView({ model: this.model }).$el)
    }
    setTrackingCode(this.model.get('trackingCode'))
    new HeaderView({
      el: this.$nav,
      model: this.headerModel,
    })

    _.bindAll(
      this,
      'decorationPageHandler',
      'emoticonPageHandler',
      'itemPageHandler',
      'classPageHandler',
      'hotdealPageHandler',
      'gachaPageHandler'
    )

    // hash router
    routie({
      decoration: this.decorationPageHandler,
      'decoration/:tab': this.decorationPageHandler,
      emoticon: this.emoticonPageHandler,
      'emoticon/:tab': this.emoticonPageHandler,
      items: this.itemPageHandler,
      pokerclass: this.classPageHandler,
      'pokerclass/:tab': this.classPageHandler,
      hotdeal: this.hotdealPageHandler,
      gacha: this.gachaPageHandler,
      '*': function () {
        // 클라에서 url hash 뒤에 &timestamp 같은 값을 추가하는 경우가 있어 삭제 후 라우팅 시도
        var splitHash = location.hash.split('&') // #hotdeal&timestamp=1234 같은 케이스 체크
        if (splitHash.length > 1) {
          routie(splitHash[0].slice(1)) // 맨 앞의 # 삭제
          return
        }

        routie('decoration')
      },
    })
  },
  // Method

  // 500003, 500002만 정기 결제 상품이고 그에 맞춰서 템플릿 변경 gift : true 면 gift 템플릿 으로
  onlyPayment: function () {
    if (!this.params.goodsId) throw new Error('상품 아이디가 없습니다.')
    if (!this.params.trackingCode) Logger.warn('trackingCode가 필요 합니다.')

    setTrackingCode(this.params.trackingCode)

    var templateName =
      (_.contains(GOODS_ID.AUTO, this.params.goodsId) && 'pokerClass') ||
      (this.params.gift && 'gift') ||
      'normal'

    pay({
      template: templateName,
      goodsList: this.model.generateGoodsArray(this.params.goodsId),
    })
  },

  pokerMallClose: function (event) {
    event.preventDefault()
    this.pokerMallRemove()
  },

  pokerMallRemove: function () {
    eventBus.off()
    routie.removeAll()
    this.remove()
    window.location.hash = ''
    Logger.info('%c POKER MALL REMOVED', 'font-size: 2em; color: red')
  },

  pokerMallBodyAppend: function (el) {
    this.$body.off().empty().append(el)
  },

  moveTab: function (number) {
    var $tab = $('.poker-mall-filter>a')
    var index = number - 1
    if (number > $tab.length || number < 1) {
      routie('decoration')
    }
    $tab.eq(index || 0).click()
  },

  // Route
  decorationPageHandler: function (tab) {
    this.headerModel.onCurrentSubmenu(0)
    this.pokerMallBodyAppend(new DecorationView().$el)
    this.moveTab(tab)
  },

  emoticonPageHandler: function (tab) {
    this.headerModel.onCurrentSubmenu(1)
    this.pokerMallBodyAppend(new EmoticonView().$el)
    this.moveTab(tab)
  },

  itemPageHandler: function () {
    this.headerModel.onCurrentSubmenu(2)
    this.pokerMallBodyAppend(new ItemsView().$el)
  },

  classPageHandler: function (tab) {
    this.headerModel.onCurrentSubmenu(3)
    this.pokerMallBodyAppend(new PokerClassView().$el)

    if (!tab && getPokerClass() === 'goldclass') {
      this.moveTab(3)
    } else {
      this.moveTab(tab)
    }
  },

  hotdealPageHandler: function () {
    this.headerModel.onCurrentSubmenu(4)
    this.pokerMallBodyAppend(new HotDealView().$el)
  },

  gachaPageHandler: function () {
    // hotdeal 상품이 없다면, 가챠가 4번째 탭이 됨
    var hotdeal = store.list.get('hotdeal')
    var hasHotdeal = hotdeal && hotdeal.length > 0

    this.headerModel.onCurrentSubmenu(hasHotdeal ? 5 : 4)
    this.pokerMallBodyAppend(new GachaView().$el)
  },

  // Event bus
  $popupShow: function (options) {
    popupModel.show(options)
  },

  // 구매 팝업
  $pay: function (options) {
    payModel.show(options)
  },

  // VIP 쿠폰 리스트 팝업
  showVipCoupons: function (event) {
    event.preventDefault()
    var coupons = store.list.get('vip_coupon_info')
    // 현재 월의 다음달 1일 00:00 구하기
    var now = new Date()
    var nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
    var yy = String(nextMonth.getFullYear()).slice(2)
    var mm = String(nextMonth.getMonth() + 1).padStart(2, '0')
    var dd = String(nextMonth.getDate()).padStart(2, '0')
    var expiredAt = `${yy}.${mm}.${dd} 00:00`

    var data = coupons.map((c) => {
      c.expired_at = expiredAt
      // (텍스트) 패턴을 <em>태그로 감싸기
      c.coupon_name = c.coupon_name.replace(/\(([^)]+)\)/g, '<em>($1)</em>')
      return c
    })

    popupModel.show({
      template: 'vipCoupons',
      title: 'VIP 쿠폰',
      vm: data,
    })
  },

  render: function () {
    Logger.info(
      'this.params',
      this.params,
      'this.paymentMode',
      this.paymentMode
    )

    var rendered = this.template.render({ isOpenedWeb: isOpenedWeb })

    if (this.paymentMode) {
      this.$el.addClass('only-payment')
    }

    // 게임 클라 / 웹 오픈 분기
    if (isOpenedGame) {
      $('html').addClass('scroll--disable')
      window.resizeTo(896, 869) // 흠 브라우저 검색창도 포함하나... (디버거에서 수동으로 크기 맞춤 포커몰 사이즈 880 830)
    }

    // view init
    this.$el.addClass('web--' + isOpenedWeb).append(rendered)

    this.$body = this.$el.find('#poker-mall-body')
    this.$popup = this.$el.find('#poker-mall-popup')
    this.$payEl = this.$el.find('#poker-mall-pay')
    this.$loading = this.$el.find('#poker-mall-loading')
    this.$nav = this.$el.find('#poker-mall-nav')

    new PopupView({
      el: this.$popup,
      model: popupModel,
    })

    this.payView = new PayView({
      el: this.$payEl,
      model: payModel,
    })

    new LoadingView({
      el: this.$loading,
    })

    Logger.info('app view render')
    return this
  },
})
